import { Avatar, Button, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { WhiteArrowRight } from 'Images';

interface IReduceMenuButton {
  closeMenu: Function | undefined;
}
export const ReduceMenuButton = ({ closeMenu }: IReduceMenuButton) => {
  return (
    <Button
      variant='textBtn'
      onClick={() => (closeMenu ? closeMenu() : undefined)}
      sx={{
        ml: 'auto',
        width: 'fit-content',
        padding: '8px 12px 8px 8px',
        borderRadius: 0,
        bgcolor: 'rgba(255, 255, 255, 0.08)',
      }}
      role='button'
    >
      <Avatar
        alt=''
        src={WhiteArrowRight}
        sx={{ width: '24px', height: '24px' }}
      />
      <Typography variant='body6' sx={{ color: 'white' }}>
        {Dictionary[DICTIONARY.General].sidebar.reduce}
      </Typography>
    </Button>
  );
};
